import { render, staticRenderFns } from "./designpage.vue?vue&type=template&id=19e94ec4&scoped=true"
import script from "./designpage.vue?vue&type=script&lang=js"
export * from "./designpage.vue?vue&type=script&lang=js"
import style0 from "./designpage.vue?vue&type=style&index=0&id=19e94ec4&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e94ec4",
  null
  
)

export default component.exports